import React, { forwardRef } from 'react';
import { cn } from '../../utils/cn';
const control = 'w-full rounded-lg border border-hairline bg-surface px-3.5 py-2.5 text-sm text-ink placeholder:text-ink-3 ' + 'transition-colors duration-150 ease-out hover:border-primary/40 focus:border-primary focus:outline-none';
export function Label({
  htmlFor,
  children,
  hint,
  required
}: {
  htmlFor?: string;
  children: React.ReactNode;
  hint?: string;
  required?: boolean;
}) {
  return <label htmlFor={htmlFor} className="mb-1.5 flex items-baseline gap-2" data-id="element-941" data-mp="d31sfvcuas0n">
      <span className="text-[13px] font-semibold text-ink" data-id="element-942" data-mp="d18mkia1wbtp">
        {children}
        {required && <span className="text-action" data-id="element-943" data-mp="hujtejev4slm"> *</span>}
      </span>
      {hint && <span className="text-[12px] text-ink-3" data-id="element-944" data-mp="mrtexnz4sk46">{hint}</span>}
    </label>;
}
export const Input = forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(function Input({
  className,
  ...rest
}, ref) {
  return <input ref={ref} className={cn(control, className)} {...rest} data-id="element-945" data-mp="wrakm5eduy05" />;
});
export const Textarea = forwardRef<HTMLTextAreaElement, React.TextareaHTMLAttributes<HTMLTextAreaElement>>(function Textarea({
  className,
  rows = 4,
  ...rest
}, ref) {
  return <textarea ref={ref} rows={rows} className={cn(control, 'resize-y', className)} {...rest} data-id="element-946" data-mp="ocqgrtrxvr3l" />;
});
export const Select = forwardRef<HTMLSelectElement, React.SelectHTMLAttributes<HTMLSelectElement>>(function Select({
  className,
  children,
  ...rest
}, ref) {
  return <select ref={ref} className={cn(control, 'appearance-none pr-9', className)} {...rest} data-id="element-947" data-mp="1c2uk0017tou2">
        {children}
      </select>;
});
export function Field({
  label,
  hint,
  error,
  required,
  id,
  children,
  className
}: {
  label: string;
  hint?: string;
  error?: string;
  required?: boolean;
  id?: string;
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={className} data-id="element-948" data-mp="1v1qc95tijt59">
      <Label htmlFor={id} hint={hint} required={required} data-id="element-949" data-mp="1v1glhg0n9hyi">
        {label}
      </Label>
      {children}
      {error && <p role="alert" className="mt-1.5 text-[12px] font-medium text-danger" data-id="element-950" data-mp="3pa2grifz8ni6">
          {error}
        </p>}
    </div>;
}
export function Switch({
  checked,
  onChange,
  label,
  description
}: {
  checked: boolean;
  onChange: (next: boolean) => void;
  label: string;
  description?: string;
}) {
  return <div className="flex items-start justify-between gap-4 py-3" data-id="element-951" data-mp="3kghf9gf6dbe8">
      <span data-id="element-952" data-mp="36hhreazhl0j4">
        <span className="block text-sm font-medium text-ink" data-id="element-953" data-mp="36hrk46bx1lsi">{label}</span>
        {description && <span className="mt-0.5 block text-[13px] text-ink-2" data-id="element-954" data-mp="3bjqmpdzu0eoe">{description}</span>}
      </span>
      <button type="button" role="switch" aria-checked={checked} aria-label={label} onClick={() => onChange(!checked)} className={cn('relative mt-0.5 inline-block h-6 w-11 shrink-0 rounded-full border transition-colors duration-150 ease-out', checked ? 'border-primary bg-primary' : 'border-hairline bg-oat')} data-id="element-955" data-mp="2wmg29f57nygj">
        <span aria-hidden="true" className={cn('absolute left-[2px] top-[2px] block h-[18px] w-[18px] rounded-full shadow-sm transition-transform duration-150 ease-out', checked ? 'translate-x-[20px] bg-on-primary' : 'translate-x-0 bg-surface')} data-id="element-956" data-mp="2kb6y07vhrx1r" />
      </button>
    </div>;
}